import { AnimatePresence, motion } from 'framer-motion'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

export default function Index() {
  return (
    <Container>
      <div>举报电话: 400-622-6190</div>
      <div>举报邮箱: service@meishubao.com</div>
      <div className="text-[12px] text-center text-[#ddd]">{import.meta.env.VITE_APP_TIME}</div>
    </Container>
  )
}

const Container = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  color: #969696;
`
